export const FETCH_KPI_BEGIN = 'FETCH_KPI_BEGIN';
export const FETCH_KPI_SUCCESS = 'FETCH_KPI_SUCCESS';
export const FETCH_KPI_ERROR = 'FETCH_KPI_ERROR';